// src/services/discargeService.js

import apiClient from "./apiClient";
const API_URL = `/ipd-discharges`; // Use relative path since apiClient has baseURL

export const createDischarge = async (dischargeData) => {
  // apiClient will automatically add organizationId via interceptor
  const response = await apiClient.post(`${API_URL}/create`, dischargeData);
  return response.data;
};

export const getDischargesByAdmissionId = async (admissionId) => {
  // apiClient will automatically add organizationId as query param via interceptor
  const response = await apiClient.get(`${API_URL}/by-admission/${admissionId}`);
  return response.data;
};

export default {
  createDischarge,
  getDischargesByAdmissionId,
}